export default "__VITE_ASSET__27bf514d__"